'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$20() {
  this.bfG = null;
  this.bfE = null;
  this.bfF = false;
  this.bfC = null;
  this.bfD = false;
  this.bfH = false;
  this.bfI = false;
  this.bfG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$20 as $c_Lpresto_PrestoRouter$$anon$20 };
$p = $c_Lpresto_PrestoRouter$$anon$20.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$20;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$20() {
}
export { $h_Lpresto_PrestoRouter$$anon$20 as $h_Lpresto_PrestoRouter$$anon$20 };
$h_Lpresto_PrestoRouter$$anon$20.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bfG;
});
$p.t = (function() {
  if ((!this.bfF)) {
    this.bfE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfF = true;
  }
  return this.bfE;
});
$p.ae = (function() {
  if ((!this.bfD)) {
    this.bfC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfD = true;
  }
  return this.bfC;
});
$p.w = (function() {
  if ((!this.bfI)) {
    this.bfH = false;
    this.bfI = true;
  }
  return this.bfH;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$20 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$20, "presto.PrestoRouter$$anon$20", ({
  NL: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$20 as $d_Lpresto_PrestoRouter$$anon$20 };
//# sourceMappingURL=presto.-Presto-Router$$anon$20.js.map
